import { sumBy } from "lodash";
import PromotionsForm from "@/pages/reservations/partials/PromotionsForm";

let isCouponApplied = false;

export default {
  components: {
    PromotionsForm
  },
  data() {
    return {
      isOpenPromotions: false,
      appliedPromotion: null,
    }
  },
  methods: {
    openPromotions() {
      this.isOpenPromotions = true;
    },
    closePromotions() {
      this.isOpenPromotions = false;
    },
    calculateTotalPrice(prices, options) {
      isCouponApplied = false;

      options = options || {};

      return sumBy(prices, price => {
        return this.calculateSinglePrice(price, options);
      });
    },
    calculateSinglePrice(price, options) {
      options = options || {};

      let result = parseFloat(price.amount);

      if (options.quantity) {
        result = result * options.quantity;
      }
      if (options.promotion) {
        result = this.calculateSinglePriceWithPromotion({
          ...price,
          amount: result
        }, options.promotion, options);
      }
      if (options.promotions) {
        result = this.calculateSinglePriceWithPromotions({
          ...price,
          amount: result
        }, options.promotions, options);
      }

      return result;
    },
    calculateSinglePriceWithPromotion(price, promotion, options) {
      let result = parseFloat(price.amount);

      if (this.isCouponPromotion(promotion)) {
        return this.calculateSinglePriceWithCoupon(price, promotion, options);
      }

      if (!price.date) {
        return this.applyPromotion(result, promotion);
      }

      const dayOfWeek = this.$moment(price.date).day();

      if (!promotion.weekdays || promotion.weekdays.indexOf(dayOfWeek) > -1) {
        result = this.applyPromotion(result, promotion);
      }

      return result;
    },
    calculateSinglePriceWithCoupon(price, coupon, options) {
      let result = parseFloat(price.amount);

      if (isCouponApplied || options.skipCoupon) {
        return result;
      }

      isCouponApplied = true;

      return this.applyPromotion(result, coupon);
    },
    calculateSinglePriceWithPromotions(price, promotions, options) {
      options = options || {};

      let result = parseFloat(price.amount);

      if (!promotions || !promotions.length) {
        return result;
      }

      promotions.forEach(promotion => {
        result = this.calculateSinglePriceWithPromotion({
          ...price,
          amount: result
        }, promotion, options);
      });

      return result;
    },
    applyPromotion(price, promotion) {
      price = parseFloat(price);

      if (!promotion) {
        return price;
      }

      if (promotion.discount_type === this.$const('ConstDiscountTypes', 'VALUE')) {
        price -= parseFloat(promotion.discount);
      } else {
        price -= parseFloat(price) * promotion.discount / 100;
      }

      return price;
    },
    isCouponPromotion(promotion) {
      return promotion.type === this.$const('ConstPropertyPromotionTypes', 'COUPON');
    },
    isCouponApplied() {
      let query = this.$route.query;

      return !!query.coupon;
    }
  }
}
